<div class="d-flex gap-0">
  <mat-icon class="toast-icon toast-icon-leading me-2 flex-shrink-0" [svgIcon]="getToastIconName()"></mat-icon>
  <div class="d-flex flex-column gap-1 flex-grow-1">
    @if (title()) {
      <div class="font-label-large font-semi-bold">
        {{ title() }}
      </div>
    }
    @if (message()) {
      <div class="font-paragraph-small font-regular font-secondary">
        {{ message() }}
      </div>
    }
  </div>
  <mat-icon class="toast-icon toast-icon-close flex-shrink-0 ms-3" [svgIcon]="'close'"></mat-icon>
</div>

<!--<div class="row" [style.display]="state().value === 'inactive' ? 'none' : ''">-->
<!--  <div class="col-9">-->
<!--    @if (title) {-->
<!--      <div [class]="options.titleClass" [attr.aria-label]="title">-->
<!--        {{ title }}-->
<!--      </div>-->
<!--    }-->
<!--    @if (message && options.enableHtml) {-->
<!--      <div role="alert"-->
<!--           [class]="options.messageClass" [innerHTML]="message">-->
<!--      </div>-->
<!--    }-->
<!--    @if (message && !options.enableHtml) {-->
<!--      <div role="alert"-->
<!--           [class]="options.messageClass" [attr.aria-label]="message">-->
<!--        {{ message }}-->
<!--      </div>-->
<!--    }-->
<!--  </div>-->
<!--  <div class="col-3 text-right">-->
<!--    @if (options.closeButton) {-->
<!--      <a (click)="remove()" class="btn btn-pink btn-sm">-->
<!--        close-->
<!--      </a>-->
<!--    }-->
<!--  </div>-->
<!--</div>-->
